import React, { useCallback, useEffect, useState } from 'react';
import { Input, InputProps, Spin } from 'antd';
import { CloseXIcon, SearchNormalIcon } from 'icons';
import debounce from 'lodash.debounce';
import { useTranslations } from 'next-intl';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';

interface IProps extends InputProps {
  refetch?: () => void;
  loading?: boolean;
}

const SearchInput: React.FC<IProps> = ({ refetch, loading, ...props }) => {
  const t = useTranslations();
  const [queryParams, setQueryParams] = useQueryParams({
    search: withDefault(StringParam, ''),
    page: withDefault(StringParam, '1')
  });
  const [tempValue, setTempValue] = useState<string>(queryParams?.search);

  useEffect(() => {
    setTempValue(queryParams?.search);
  }, [queryParams?.search]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetSearch = useCallback(
    debounce((val: string) => {
      setQueryParams({
        search: val || undefined,
        page: undefined
      });
      if (refetch) {
        refetch();
      }
    }, 500),
    []
  );

  const onClear = () => {
    setTempValue('');
    setQueryParams({
      search: undefined
    });
    if (refetch) {
      refetch();
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;

    setTempValue(val);
    debouncedSetSearch(val);

    if (props?.onChange) {
      props?.onChange(e);
    }
  };

  return (
    <div className="flex h-9 items-center rounded-lg bg-white px-2 md:w-60 md:bg-gray-100">
      <SearchNormalIcon />
      <Input
        {...props}
        value={tempValue}
        onChange={onChange}
        className="placeholder:!text-md placeholder:!ml-4.5 !border-transparent !bg-transparent !shadow-none placeholder:!font-medium"
        size="small"
        placeholder={t('Qidiruv')}
      />
      {tempValue &&
        (loading ? (
          <Spin size="small" spinning={loading} />
        ) : (
          <div
            onClick={onClear}
            className="flex max-h-5 max-w-5 cursor-pointer items-center justify-center rounded-full bg-gray-200 p-0.5"
          >
            <CloseXIcon size="10" color="#475467" />
          </div>
        ))}
    </div>
  );
};

export default SearchInput;
